import { Observer } from "mobx-react-lite";
import React from 'react';
import joinClassName from "../../../utils/className.utils";
import { useProps, useStore } from "../../../utils/mobx.utils";
import './ServiceResultItem.scss';
export var serviceToColorMap = {
    "one-to-one-counselling": "brightPurple",
    "young-people-counselling": "orange",
    "couples-counselling": "red",
    "peer-support": "deepPurple",
    "support-groups": "emerald",
    "frontline-workers": "blueGreen",
};
export var getServiceColor = function (serviceName) {
    var _a;
    var parsedServiceName = serviceName.toLowerCase().replace(" ", "-");
    return (_a = serviceToColorMap[parsedServiceName]) !== null && _a !== void 0 ? _a : "";
};
var ServiceResultItem = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get service() {
            return p.result;
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement(React.Fragment, null,
            React.createElement("li", { className: joinClassName("ServiceResultItem") },
                React.createElement("a", { className: joinClassName("SearchItemTextColorable", getServiceColor(s.service.slug), "SearchItemHoverColorable", s.service.slug), href: s.service.link },
                    React.createElement("h3", null, s.service.title.rendered))))); } });
};
export default ServiceResultItem;
